import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex shrink-0 items-center justify-center gap-2 rounded-control font-medium whitespace-nowrap transition-[background-color,border-color,color,box-shadow,transform] duration-150 select-none active:translate-y-px disabled:pointer-events-none disabled:opacity-55 [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary:
          'bg-brand-600 text-white shadow-[0_1px_0_0_rgb(255_255_255/0.15)_inset,var(--shadow-xs)] hover:bg-brand-700',
        gradient:
          'bg-gradient-to-br from-brand-500 to-accent-600 text-white shadow-brand hover:from-brand-600 hover:to-accent-600',
        secondary:
          'border border-line bg-surface text-ink-soft shadow-xs hover:border-line-strong hover:bg-surface-muted hover:text-ink',
        soft: 'bg-brand-50 text-brand-700 hover:bg-brand-100',
        ghost: 'text-ink-soft hover:bg-surface-sunken hover:text-ink',
        danger: 'bg-danger-600 text-white shadow-xs hover:bg-danger-700',
        'danger-soft': 'bg-danger-50 text-danger-700 hover:bg-danger-100',
        link: 'h-auto px-0 text-brand-600 underline-offset-4 hover:text-brand-700 hover:underline',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-10 px-4 text-sm',
        lg: 'h-11 px-5 text-sm',
        icon: 'size-9',
        'icon-sm': 'size-8',
      },
      block: { true: 'w-full' },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)
